define('areas/shopitemtemplate/models/dto',["require", "exports"], function (require, exports) {
    "use strict";
    var Template = (function () {
        function Template() {
        }
        return Template;
    }());
    exports.Template = Template;
    var ShopItemStub = (function () {
        function ShopItemStub() {
        }
        return ShopItemStub;
    }());
    exports.ShopItemStub = ShopItemStub;
});

